<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          appInfo = data?.metaData
          this.isLoading = false
        }
      "
      contentId="appInfo"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Configurations Supplémentaires</div>
      <div>
        <button class="buttonComponent" @click="saveData" v-if="haveUpdate">
          Enrégister
        </button>
      </div>
    </div>
    <div class="py-2"></div>
    <!-- {{ appInfo }} -->

    <div class="flex flex-col gap-6">
      <div class="bg-white rounded-2xl p-4 flex flex-col">
        <div class="font-bold">Liens sociaux</div>
        <div class="py-2"></div>
        <InputComponent
          type="url"
          v-model="updatedData.whatsappUrl"
          label="Lien whatsapp"
        />
        <InputComponent
          type="url"
          v-model="updatedData.facebookUrl"
          label="Lien facebook"
        />
        <InputComponent
          type="url"
          v-model="updatedData.snapchatUrl"
          label="Lien snapchat"
        />
        <InputComponent
          type="url"
          v-model="updatedData.linkedinUrl"
          label="Lien linkedin"
        />
        <InputComponent
          type="url"
          v-model="updatedData.instagramUrl"
          label="Lien instagram"
        />
        <InputComponent
          type="url"
          v-model="updatedData.tiktokUrl"
          label="Lien tiktok"
        />
      </div>
      <div class="py-24"></div>
    </div>

    <EventListener
      :events="['app_info_saved', 'failed_to_save_app_info']"
      @app_info_saved="onInfoSaved"
      @failed_to_save_app_info="onFailedToSave"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import InputComponent from '@/components/utils/InputComponent.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    InputComponent,
    EventListener,
  },
  data() {
    return {
      appInfo: {},
      updatedData: {},
      isLoading: true,
      haveUpdate: false,
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    saveData() {
      this.$Events.dispatchEvent('app_info_update_available', this.updatedData)
    },
    onInfoSaved() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Infos enrégistrées correctement',
        body: 'Les informations ont été enrégistrées avec succès',
      })
      this.updatedData = JSON.parse(JSON.stringify(this.appInfo))
      this.haveUpdate = false
      setTimeout(() => {
        this.haveUpdate = false
      })
      setTimeout(() => {
        this.haveUpdate = false
      }, 100)
    },
    onFailedToSave() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de sauvegarde',
        body: 'Désolé, les données ne sont pas enrégistrée, veuillez réessayer',
      })
    },
    availabilityDisplay(data) {
      return data
    },
  },
  watch: {
    appInfo(newVal) {
      if (!this.haveUpdate) {
        this.updatedData = JSON.parse(JSON.stringify(newVal))
        this.haveUpdate = false
        setTimeout(() => {
          this.haveUpdate = false
        })
        setTimeout(() => {
          this.haveUpdate = false
        }, 100)
      }
    },
    updatedData: {
      deep: true,
      handler() {
        this.haveUpdate = true
      },
    },
  },
  computed: {
    // haveUpdate() {
    //   return JSON.stringify(this.appInfo) !== JSON.stringify(this.updatedData)
    // },
  },
}
</script>
